export default __webpack_public_path__ + "static/media/help-blue.cf4a02ac.svg";